import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { setToken } from '@/services/token'

export default function TokenHandler() {
  const navigate = useNavigate()
  const { token } = useParams()
  const [q] = useSearchParams()
  const redirect = q.get('url') || '/home'
  useEffect(() => {
    if (token) {
      setToken(token)
    }
    navigate(redirect, { replace: true })
  }, [navigate, token, redirect])
  return null
}
